import type { IconAsset } from '../Icon.types';

export const basket: IconAsset = {
  regular: {
    l: {
      code: (
        <path
          clipRule='evenodd'
          d='M16.4729 2H7.5271L5.34528 7H4C2.89543 7 2 7.89543 2 9V20C2 21.1046 2.89543 22 4 22H20C21.1046 22 22 21.1046 22 20V9C22 7.89543 21.1046 7 20 7H18.6547L16.4729 2ZM16.4726 7L15.1635 4H8.83649L7.5274 7H16.4726ZM4 9H20V20H4V9Z'
          fill='currentColor'
          fillRule='evenodd'
        />
      ),
    },
    m: {
      code: (
        <path
          clipRule='evenodd'
          d='M13.8258 2H6.1743L4.35611 6H4C2.89543 6 2 6.89543 2 8V16C2 17.1046 2.89543 18 4 18H16C17.1046 18 18 17.1046 18 16V8C18 6.89543 17.1046 6 16 6H15.6439L13.8258 2ZM13.447 6L12.5379 4H7.46212L6.55303 6H13.447ZM4 8H16V16H4V8Z'
          fill='currentColor'
          fillRule='evenodd'
        />
      ),
    },
    s: {
      code: (
        <path
          clipRule='evenodd'
          d='M11.2459 1H4.75409L3.29955 5H3C1.89543 5 1 5.89543 1 7V13C1 14.1046 1.89543 15 3 15H13C14.1046 15 15 14.1046 15 13V7C15 5.89543 14.1046 5 13 5H12.7004L11.2459 1ZM10.5723 5L9.845 3H6.15495L5.42767 5H10.5723ZM3 7H13V13H3L3 7Z'
          fill='currentColor'
          fillRule='evenodd'
        />
      ),
    },
  },
  bold: {
    l: {
      code: (
        <path
          clipRule='evenodd'
          d='M16.8002 2H7.19977L5.01795 7H4C2.89543 7 2 7.89543 2 9V20C2 21.1046 2.89543 22 4 22H20C21.1046 22 22 21.1046 22 20V9C22 7.89543 21.1046 7 20 7H18.982L16.8002 2ZM15.7089 7L14.8361 5H9.16386L8.29113 7H15.7089ZM5 19V10H19V19H5Z'
          fill='currentColor'
          fillRule='evenodd'
        />
      ),
    },
    m: {
      code: (
        <path
          clipRule='evenodd'
          d='M14.2325 1H5.76756L3.94915 6.00063C2.86808 6.02761 2 6.91243 2 8V16C2 17.1046 2.89543 18 4 18H16C17.1046 18 18 17.1046 18 16V8C18 6.91245 17.1319 6.02764 16.0509 6.00064L14.2325 1ZM12.8585 6L12.1312 4H7.86884L7.14157 6H12.8585ZM5 15V9H15V15H5Z'
          fill='currentColor'
          fillRule='evenodd'
        />
      ),
    },
    s: {
      code: (
        <path
          clipRule='evenodd'
          d='M11.5961 0H4.40393L2.59033 4.98739L2.62502 5H2C0.895431 5 0 5.89543 0 7V14C0 15.1046 0.895431 16 2 16H14C15.1046 16 16 15.1046 16 14V7C16 5.89543 15.1046 5 14 5H13.375L13.4097 4.98739L11.5961 0ZM10.2221 5L9.49484 3H6.50521L5.77794 5H10.2221ZM3 13V8H13V13H3Z'
          fill='currentColor'
          fillRule='evenodd'
        />
      ),
    },
  },
};
